import React, { useState } from 'react';

function DismissForm({ employee, onSave, onClose }) {
  const today = (() => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
})();

  const [date, setDate] = useState(
    employee.dismissal_date?.split('T')[0] || today
  );
  const [error, setError] = useState('');

  // Считаем дней до увольнения
  const days = date
    ? Math.ceil((new Date(date) - new Date(today)) / (1000 * 60 * 60 * 24))
    : 0;

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!date) {
      setError('Укажите дату увольнения');
      return;
    }

    onSave({ dismissal_date: date });
  };

  const handleCancelDismiss = () => {
    if (!window.confirm('Отменить увольнение? Сотрудник вернётся в штат.')) return;
    onSave({ dismissal_date: null });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>⚠️ Увольнение — {employee.full_name}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-body">
          <div className="form-group">
            <label>Дата увольнения</label>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              required
            />
          </div>

          {days >= 0 && (
            <div className="dismiss-days-info">
              {days === 0 ? (
                <>🗓 Увольняется <b>сегодня</b></>
              ) : days === 1 ? (
                <>🗓 Увольняется <b>завтра</b></>
              ) : (
                <>🗓 Осталось <b>{days} {days < 5 ? 'дня' : 'дней'}</b></>
              )}
            </div>
          )}

          {days < 0 && (
            <div className="dismiss-days-info" style={{ background: '#ffebee', color: '#c62828' }}>
              ⚠️ Дата уже прошла — укажите будущую или нажмите «Уволить сейчас»
            </div>
          )}

          {error && <div className="login-error">{error}</div>}

          <div className="modal-footer">
            {employee.dismissal_date && (
              <button
                type="button"
                className="btn-cancel-dismiss"
                onClick={handleCancelDismiss}
              >
                🚫 Отменить увольнение
              </button>
            )}
            <div className="modal-footer-right">
              <button type="button" className="btn-cancel" onClick={onClose}>
                Отмена
              </button>
              <button type="submit" className="btn-dismiss-confirm">
                Уволить
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default DismissForm;